// extracted by mini-css-extract-plugin
export default {"panel":"CompanyPassengersPanel_panel__7oEGR","listPanel":"CompanyPassengersPanel_listPanel__9yq2m"};